const DEFAULT_PIXEL_ID = '1711354553421592';

export const getMetaPixelId = () =>
  process.env.REACT_APP_META_PIXEL_ID || DEFAULT_PIXEL_ID;

let scriptPromise = null;
let pageViewTracked = false;

const ensureFbq = () => {
  if (typeof window === 'undefined') return null;
  if (window.fbq) return window.fbq;

  // Meta base snippet (queue before script loads)
  // eslint-disable-next-line func-names
  const fbq = function () {
    // eslint-disable-next-line prefer-rest-params, prefer-spread
    if (fbq.callMethod) {
      // eslint-disable-next-line prefer-spread, prefer-rest-params
      fbq.callMethod.apply(fbq, arguments);
    } else {
      // eslint-disable-next-line prefer-rest-params
      fbq.queue.push(arguments);
    }
  };
  if (!window._fbq) window._fbq = fbq;
  fbq.push = fbq;
  fbq.loaded = true;
  fbq.version = '2.0';
  fbq.queue = [];
  window.fbq = fbq;
  return fbq;
};

export const loadMetaPixel = (pixelId = getMetaPixelId()) => {
  if (typeof window === 'undefined' || !pixelId) return Promise.resolve();

  const fbq = ensureFbq();

  if (!scriptPromise) {
    scriptPromise = new Promise((resolve, reject) => {
      const existing = document.querySelector(
        'script[src="https://connect.facebook.net/en_US/fbevents.js"]'
      );
      if (existing) {
        resolve();
        return;
      }
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      script.onload = () => resolve();
      script.onerror = () => reject(new Error('Meta Pixel failed to load'));
      document.head.appendChild(script);
    });
  }

  if (!window.__runamaticPixelInited) {
    fbq('init', pixelId);
    window.__runamaticPixelInited = pixelId;
  }

  return scriptPromise.catch(() => {});
};

export const trackPageView = () => {
  if (typeof window === 'undefined' || pageViewTracked) return;
  const fbq = ensureFbq();
  fbq('track', 'PageView');
  pageViewTracked = true;
};

export const trackMetaEvent = (eventName, params = {}, eventData = {}) => {
  if (typeof window === 'undefined' || !eventName) return;
  const fbq = ensureFbq();
  if (Object.keys(eventData).length > 0) {
    fbq('track', eventName, params, eventData);
  } else {
    fbq('track', eventName, params);
  }
};

/** Advanced Matching: re-init with hashed-ready plain user data (Meta hashes client-side). */
export const setAdvancedMatching = (userData = {}) => {
  if (typeof window === 'undefined') return;
  const pixelId = getMetaPixelId();
  const fbq = ensureFbq();
  const payload = {};
  if (userData.em) payload.em = String(userData.em).trim().toLowerCase();
  if (userData.ph) payload.ph = String(userData.ph).replace(/\D/g, '');
  if (userData.fn) payload.fn = String(userData.fn).trim().toLowerCase();
  if (userData.ln) payload.ln = String(userData.ln).trim().toLowerCase();
  if (userData.country) payload.country = String(userData.country).trim().toLowerCase();
  if (Object.keys(payload).length === 0) return;
  fbq('init', pixelId, payload);
};

export const resetPageViewFlagForTests = () => {
  pageViewTracked = false;
};
